import styled from 'styled-components';
var Divider = /*#__PURE__*/styled.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-5n75n-0"
})(["display:block;height:auto;margin:0;border-bottom:0;border-left:0;border-top:1px solid;border-right:1px solid;border-color:", ";border-width:1px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.divider.primary;
});
Divider.displayName = 'Divider';
export default Divider;